export const WHATSAPP_NUMBER = "918180951635";
export const WHATSAPP_DISPLAY = "+91 81809 51635";
export const INSTAGRAM_URL = "https://instagram.com/raj_travels_goa";
export const LOGO_URL = "/assets/rtg-logo-256.webp";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1541417904950-b855846fe074?auto=format&fit=crop&w=1920&q=72",
  palolem: "https://images.unsplash.com/photo-1727193120023-12c48606b803?auto=format&fit=crop&w=1200&q=70",
  caboDeRama: "https://images.unsplash.com/photo-1642516864726-a243f416fc00?auto=format&fit=crop&w=1200&q=70",
  bestSeller: "https://images.unsplash.com/photo-1614082242765-7c98ca0f3df3?auto=format&fit=crop&w=1200&q=70",
  couple: "https://images.unsplash.com/photo-1575388104683-e076ee9ccaa0?auto=format&fit=crop&w=1200&q=70",
  family: "https://images.unsplash.com/photo-1693020077268-1a3b572103c1?auto=format&fit=crop&w=1200&q=70",
  resort: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&w=1200&q=70",
  nightlife: "https://images.unsplash.com/photo-1682743710558-b338ba285925?auto=format&fit=crop&w=1200&q=70",
  coupleSunset: "https://images.unsplash.com/photo-1615966650071-855b15f29ad1?auto=format&fit=crop&w=1200&q=70",
  villa: "https://images.unsplash.com/photo-1587922546307-776227941871?auto=format&fit=crop&w=1200&q=70",
  northGoa: "https://images.unsplash.com/photo-1583401535382-a0814c295b0b?auto=format&fit=crop&w=1200&q=70",
  waterAdventure: "https://images.unsplash.com/photo-1632904074880-b77f02b6d01e?auto=format&fit=crop&w=1200&q=70",
  goanFood: "https://images.unsplash.com/photo-1559561724-732dbca7be1e?auto=format&fit=crop&w=1200&q=70",
  luxuryStay: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1200&q=70",
};

export const PACKAGES = [
  {
    id: "best-seller",
    name: "Best-Selling Goa Package",
    duration: "3 Nights / 4 Days",
    price: "₹8,999",
    badge: "BEST SELLER",
    designedFor: null,
    image: IMAGES.bestSeller,
    alt: "Beautiful Goa beachfront with colorful coastal huts and palms",
    inclusions: [
      "Hotel stay with breakfast",
      "Airport or railway station pickup and drop",
      "North Goa sightseeing on SIC",
      "South Goa sightseeing on SIC",
      "Dinner cruise on SIC",
    ],
    itinerary: [
      { day: "Day 1", title: "Arrival & Beach Sunset", desc: "Pickup from Goa airport / railway station. Check in to your hotel and spend the evening at Calangute–Baga beach shacks and the sunset promenade." },
      { day: "Day 2", title: "North Goa Sightseeing (SIC)", desc: "Fort Aguada and lighthouse, Sinquerim, Anjuna and Vagator cliff viewpoints — the classic North Goa circuit with fellow travellers." },
      { day: "Day 3", title: "South Goa Sightseeing & Dinner Cruise (SIC)", desc: "Old Goa churches, Miramar and Dona Paula. Evening Mandovi dinner cruise with Goan folk music and dance." },
      { day: "Day 4", title: "Souvenirs & Departure", desc: "Leisure breakfast, checkout and a comfortable drop back to the airport or railway station." },
    ],
  },
  {
    id: "couple-special",
    name: "Best Couple Package with Private Taxi",
    duration: "4 Nights / 5 Days",
    price: "₹14,999",
    badge: "COUPLE SPECIAL",
    designedFor: "Couples",
    image: IMAGES.couple,
    alt: "Romantic couple enjoying a Goa seaside sunset",
    inclusions: [
      "Hotel stay with breakfast",
      "Airport or railway station pickup and drop",
      "North Goa sightseeing by private taxi",
      "South Goa sightseeing by private taxi",
      "Dinner cruise with private taxi transfers",
    ],
    itinerary: [
      { day: "Day 1", title: "Private Welcome & Check-in", desc: "Chauffeured pickup with a warm welcome. Check in and enjoy a relaxed evening on the beach, just the two of you." },
      { day: "Day 2", title: "North Goa by Private Taxi", desc: "Explore Fort Aguada, Anjuna, Vagator cliffs and Candolim at your own pace — your taxi, your schedule." },
      { day: "Day 3", title: "South Goa by Private Taxi", desc: "Old Goa heritage churches, Dona Paula viewpoint and the serene white sands of Colva or Palolem." },
      { day: "Day 4", title: "Romantic Dinner Cruise", desc: "Free day for cafe-hopping and shopping. Evening Mandovi dinner cruise with private taxi transfers both ways." },
      { day: "Day 5", title: "Slow Morning & Departure", desc: "Breakfast together, checkout and a smooth private drop to the airport or station." },
    ],
  },
  {
    id: "family-special",
    name: "Best Family Package",
    duration: "4 Nights / 5 Days",
    price: "₹11,999",
    badge: "FAMILY SPECIAL",
    designedFor: "4 passengers",
    image: IMAGES.family,
    alt: "Happy family enjoying a tropical Goa beach holiday",
    inclusions: [
      "Hotel stay with breakfast",
      "Airport or railway station pickup and drop",
      "North Goa sightseeing on SIC",
      "South Goa sightseeing on SIC",
      "Dinner cruise on SIC",
    ],
    itinerary: [
      { day: "Day 1", title: "Comfortable Arrival", desc: "Family pickup and smooth check-in. Evening free for a safe family beach walk and shack dinner." },
      { day: "Day 2", title: "North Goa Family Fun (SIC)", desc: "Fort Aguada, Chapora ('Dil Chahta Hai') viewpoint and family-friendly beaches with plenty of photo stops." },
      { day: "Day 3", title: "South Goa Highlights (SIC)", desc: "Old Goa churches, Miramar beach and Dona Paula — sights every generation enjoys together." },
      { day: "Day 4", title: "Dinner Cruise Evening (SIC)", desc: "Relaxed morning, then the famous Mandovi dinner cruise with live Goan music, dance and dinner." },
      { day: "Day 5", title: "Sweet Memories & Drop", desc: "Pick up Goan sweets and cashews with driver guidance before your departure transfer." },
    ],
  },
];

export const EXPERIENCES = [
  { tag: "FORTS & BEACHES", title: "Explore North Goa", desc: "Chapora Fort views, Baga–Calangute shores, beach shacks, flea markets and buzzing cafes.", image: IMAGES.northGoa, alt: "Chapora Fort hill and panoramic sea view in North Goa", interest: "Explore North Goa" },
  { tag: "SERENE SOUTH", title: "Discover South Goa", desc: "Palolem's crescent bay, Cabo de Rama cliffs, Colva's white sands and Old Goa heritage churches.", image: IMAGES.palolem, alt: "Palolem beach crescent bay with palms in South Goa", interest: "Discover South Goa" },
  { tag: "THRILL & OCEAN", title: "Adventure & Water Activities", desc: "Parasailing, jet skis, scuba diving, banana rides and island trips across blue Goan waters.", image: IMAGES.waterAdventure, alt: "Parasailing over the blue sea with a speedboat in Goa", interest: "Adventure & Water Activities" },
  { tag: "AFTER DARK", title: "Nightlife & Party Experiences", desc: "Beach clubs, live music, sunset parties and Goa's legendary night scene — planned safely.", image: IMAGES.nightlife, alt: "Goa beach club lit up with string lights at night", interest: "Nightlife & Party Experiences" },
  { tag: "STAY IN STYLE", title: "Premium Stays & Romantic Escapes", desc: "Handpicked resorts, private pool villas and candlelight dinners for couples and families.", image: IMAGES.luxuryStay, alt: "Luxury tropical resort room opening to a private pool", interest: "Premium Stays & Romantic Escapes" },
  { tag: "TASTE OF GOA", title: "Food & Local Culture", desc: "Fish thalis, beach shacks, spice farms, local markets and warm Goan hospitality.", image: IMAGES.goanFood, alt: "Authentic Goan coastal thali with fish fry and curries", interest: "Food & Local Culture" },
];

export const PICKUP_OPTIONS = [
  "Goa Airport",
  "Railway Station - Madgaon",
  "Railway Station - Thivim",
  "Railway Station - Vasco da Gama",
  "Bus Stand - Panaji",
  "Bus Stand - Mapusa",
  "Hotel in Goa",
  "Other / Specify Location",
];

export const BUDGET_OPTIONS = [
  "Under Rs 5,000",
  "Rs 5,000 - Rs 10,000",
  "Rs 10,000 - Rs 15,000",
  "Rs 15,000 - Rs 25,000",
  "Rs 25,000 - Rs 50,000",
  "Above Rs 50,000",
  "Need a suggestion",
];

export const INTEREST_OPTIONS = [
  "Explore North Goa",
  "Discover South Goa",
  "Adventure & Water Activities",
  "Nightlife & Party Experiences",
  "Premium Stays & Romantic Escapes",
  "Food & Local Culture",
];

export const BEACH_GALLERY = [
  { id: "baga-beach", name: "Baga Beach", url: "https://images.unsplash.com/photo-1654074144552-77b10d94e68c?auto=format&fit=crop&w=1200&q=70", alt: "Lively shoreline with palm trees at Baga Beach Goa" },
  { id: "vagator-beach", name: "Vagator Beach", url: "https://images.unsplash.com/photo-1652092521226-3e03a716ae86?auto=format&fit=crop&w=1200&q=70", alt: "Dramatic rocky cliff and golden beach at Vagator Goa" },
  { id: "colva-beach", name: "Colva Beach", url: "https://images.unsplash.com/photo-1719555793391-aad31b144e61?auto=format&fit=crop&w=1200&q=70", alt: "Serene wide sandy shoreline at Colva Beach South Goa" },
  { id: "morjim-beach", name: "Morjim Beach", url: "https://images.unsplash.com/photo-1716305932153-8d7e80505e58?auto=format&fit=crop&w=1200&q=70", alt: "Peaceful tropical shore and ocean view at Morjim Beach Goa" },
  { id: "dona-paula", name: "Dona Paula", url: "https://images.unsplash.com/photo-1713777072955-f9e9d0657df4?auto=format&fit=crop&w=1200&q=70", alt: "Scenic coastal bay viewpoint overlooking turquoise water at Dona Paula Goa" },
  { id: "butterfly-beach", name: "Butterfly Beach", url: "https://images.unsplash.com/photo-1759082105507-95d6cebbad87?auto=format&fit=crop&w=1200&q=70", alt: "Secluded tropical cove beach nestled against lush jungle at Butterfly Beach Goa" },
];
